import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const ConsultancyHome = () => {
  const [activeTab, setActiveTab] = useState("crm");
  const [openFaq, setOpenFaq] = useState(0);

  useEffect(() => {
    if (window.location.hash === "#pricing") {
      setTimeout(() => {
        const el = document.getElementById("pricing");
        if (el) {
          const y = el.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 300);
    }
  }, []);

  const problems = [
    { title: "Scattered Leads", desc: "Leads are spread across Excel sheets, WhatsApp messages, emails, and multiple disconnected systems.", icon: "fa-sitemap" },
    { title: "Missed Follow-ups", desc: "Counsellors forget critical follow-up deadlines, causing hot student enquiries to go cold.", icon: "fa-calendar-times" },
    { title: "Application Chaos", desc: "Tracking university application stages manually becomes overwhelming as student volume increases.", icon: "fa-exclamation-triangle" },
    { title: "No Business Visibility", desc: "Consultancy owners lack real-time visibility into branch revenues, conversion rates, and counsellor productivity.", icon: "fa-eye-slash" },
    { title: "Document Confusion", desc: "Student passports, marksheets, SOPs, and financial documents are lost in messy email threads.", icon: "fa-file-alt" },
    { title: "Difficult Scaling", desc: "Expanding to new branch offices or onboarding regional sub-agents creates operational bottlenecks.", icon: "fa-chart-line" },
  ];

  const solutionModules = [
    { title: "Lead Management CRM", desc: "Automate lead capture & scoring", icon: "fa-user-check" },
    { title: "Counselling Workspace", desc: "Daily student follow-up queues", icon: "fa-comments" },
    { title: "Application Tracker", desc: "Multi-stage admission pipeline", icon: "fa-clipboard-list" },
    { title: "University Catalog", desc: "1,000+ course eligibility engine", icon: "fa-university" },
    { title: "Document Vault", desc: "Secure student document storage", icon: "fa-folder-open" },
    { title: "Visa Ops Desk", desc: "Checklists & visa filing stages", icon: "fa-passport" },
    { title: "Task Reminders", desc: "Zero missed enquiry follow-ups", icon: "fa-bell" },
    { title: "Communication Log", desc: "WhatsApp & email chat histories", icon: "fa-headset" },
    { title: "Commission Engine", desc: "Partner splits & invoice tracking", icon: "fa-coins" },
    { title: "Reports & Analytics", desc: "Live counsellor & branch metrics", icon: "fa-chart-pie" },
    { title: "Branch Manager", desc: "Multi-location agency hierarchy", icon: "fa-building" },
    { title: "Team Permissions", desc: "Granular RBAC role security", icon: "fa-user-shield" },
  ];

  const pipelineStages = [
    { title: "New Lead", count: 42, color: "border-info" },
    { title: "Contacted", count: 28, color: "border-primary" },
    { title: "Counselling", count: 19, color: "border-warning" },
    { title: "Application", count: 14, color: "border-purple" },
    { title: "Offer Recd", count: 9, color: "border-teal" },
    { title: "Visa Filed", count: 6, color: "border-danger" },
    { title: "Enrolled 🎓", count: 5, color: "border-success" },
  ];

  const counsellors = [
    { rank: 1, name: "Priya Sharma", leads: 120, conversion: "86%", revenue: "₹8.4L", avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=150&q=80" },
    { rank: 2, name: "Rahul Verma", leads: 105, conversion: "79%", revenue: "₹6.8L", avatar: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=150&q=80" },
    { rank: 3, name: "Ananya Roy", leads: 95, conversion: "74%", revenue: "₹5.6L", avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=150&q=80" },
  ];

  const branches = [
    { branch: "Hyderabad HQ", leads: 450, applications: 180, revenue: "₹42.5L", conversion: "38%" },
    { branch: "Bangalore Branch", leads: 320, applications: 130, revenue: "₹28.9L", conversion: "35%" },
    { branch: "Chennai Branch", leads: 280, applications: 110, revenue: "₹22.4L", conversion: "32%" },
    { branch: "Mumbai Branch", leads: 240, applications: 95, revenue: "₹19.8L", conversion: "30%" },
  ];

  const integrations = [
    { name: "WhatsApp Business API", icon: "fab fa-whatsapp" },
    { name: "Gmail & Outlook", icon: "fas fa-envelope" },
    { name: "Google Workspace", icon: "fab fa-google" },
    { name: "Microsoft 365", icon: "fab fa-microsoft" },
    { name: "Stripe & Razorpay", icon: "fas fa-credit-card" },
    { name: "University API Gateways", icon: "fas fa-university" },
  ];

  const faqs = [
    { q: "Who is EdOps OS designed for?", a: "EdOps OS is built specifically for overseas education consultancy owners, study abroad agency managers, franchise operators, and educational counsellors looking to manage operations and scale admissions." },
    { q: "Can I manage multiple branch offices and sub-agents?", a: "Yes! EdOps OS supports multi-tenant branch management. Agency owners can track lead distribution, conversion rates, and revenue streams across all branches in real time." },
    { q: "How does counsellor performance tracking work?", a: "The platform tracks assigned leads, completed follow-ups, application submission rates, visa approvals, and revenue generated per counsellor, presenting live leaderboards and analytics." },
    { q: "Is our agency's student and financial data secure?", a: "Absolutely. We enforce enterprise-grade role-based access control (RBAC), end-to-end SSL encryption, daily automated backups, and strict data isolation for every consultancy." },
    { q: "Can we import existing lead data from spreadsheets?", a: "Yes, you can import leads, student records, and application logs seamlessly using our 1-click Excel/CSV bulk data import tool." },
  ];

  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      {/* 1. HERO SECTION */}
      <section className="py-5 text-center position-relative">
        <div className="container py-4">
          <div className="consultancy-badge-gold mb-3 mx-auto" style={{ maxWidth: "380px" }}>
            <i className="fas fa-cubes text-warning"></i> The Operating System for Consultancies
          </div>
          <h1 className="display-4 font-weight-bold consultancy-gold-title mb-3" style={{ maxWidth: "900px", margin: "0 auto" }}>
            Run Your Entire Overseas Education Consultancy From <span className="consultancy-gradient-text">One Platform.</span>
          </h1>
          <p className="consultancy-lead-text mx-auto mb-4" style={{ maxWidth: "760px" }}>
            Manage leads, counsellors, applications, universities, documents, follow-ups, commissions, and business performance — all from one intelligent AI SaaS platform.
          </p>

          <div className="d-flex justify-content-center gap-3 mb-4 flex-wrap">
            <Link to="/consultancy/book-consultation" className="consultancy-btn-gold px-4 py-3">
              Book a Demo <i className="fas fa-desktop ml-1"></i>
            </Link>
            <Link to="/consultancy/services" className="consultancy-btn-outline-gold px-4 py-3">
              Explore Platform <i className="fas fa-arrow-right ml-1"></i>
            </Link>
          </div>

          <div className="small text-muted font-weight-bold mb-5">
            <i className="fas fa-shield-alt text-warning mr-1"></i> Built for modern overseas education consultancies.
          </div>

          {/* HERO VISUAL: SAAS DASHBOARD MOCKUP WITH FLOATING CARDS */}
          <div className="position-relative mx-auto mt-4" style={{ maxWidth: "1280px" }}>
            <div className="dashboard-mockup-frame p-2 p-md-4">
              <div className="dashboard-mockup-header mb-3">
                <div className="d-flex align-items-center gap-2">
                  <span className="badge bg-danger rounded-circle p-1"></span>
                  <span className="badge bg-warning rounded-circle p-1"></span>
                  <span className="badge bg-success rounded-circle p-1"></span>
                  <span className="small text-muted ml-2">EdOps Consultancy Operating Portal v4.2</span>
                </div>
                <span className="badge bg-soft-warning text-warning font-weight-bold">Live Business Analytics</span>
              </div>

              <div className="row g-3 text-start">
                <div className="col-md-3">
                  <div className="consultancy-pill-card p-3">
                    <small className="text-muted font-weight-bold d-block">TOTAL LEADS</small>
                    <span className="fs-3 font-weight-bold text-white">1,248</span>
                    <small className="text-success d-block font-weight-bold mt-1"><i className="fas fa-arrow-up"></i> +18% this month</small>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="consultancy-pill-card p-3">
                    <small className="text-muted font-weight-bold d-block">ACTIVE APPLICATIONS</small>
                    <span className="fs-3 font-weight-bold text-warning">482</span>
                    <small className="text-warning d-block font-weight-bold mt-1">142 Submitted</small>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="consultancy-pill-card p-3">
                    <small className="text-muted font-weight-bold d-block">OFFERS RECEIVED</small>
                    <span className="fs-3 font-weight-bold text-info">215</span>
                    <small className="text-info d-block font-weight-bold mt-1">94% Approval SLA</small>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="consultancy-pill-card p-3">
                    <small className="text-muted font-weight-bold d-block">MONTHLY REVENUE</small>
                    <span className="fs-3 font-weight-bold text-success">₹24.8L</span>
                    <small className="text-success d-block font-weight-bold mt-1">Commissions Settled</small>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating UI Panel 1 */}
            <div className="position-absolute consultancy-floating-badge d-none d-md-flex" style={{ top: "-45px", left: "-45px" }}>
              <i className="fas fa-chart-line text-warning fa-lg"></i>
              <div>
                <strong className="text-white d-block">+28% Lead Conversion</strong>
                <small className="text-muted">Automated CRM Reminders</small>
              </div>
            </div>

            {/* Floating UI Panel 2 */}
            <div className="position-absolute consultancy-floating-badge d-none d-md-flex" style={{ bottom: "-20px", right: "-20px", animationDelay: "2s" }}>
              <i className="fas fa-check-circle text-success fa-lg"></i>
              <div>
                <strong className="text-white d-block">86% Follow-up Rate</strong>
                <small className="text-muted">Zero Missed Opportunities</small>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 2. TRUSTED BY CONSULTANCIES */}
      <section className="py-4 consultancy-section-dark text-center">
        <div className="container">
          <small className="text-muted font-weight-bold text-uppercase d-block mb-3" style={{ letterSpacing: "1.5px" }}>
            Built for the way education consultancies actually work
          </small>
          <div className="d-flex justify-content-center align-items-center gap-5 flex-wrap opacity-75">
            <span className="fs-5 font-weight-bold text-muted"><i className="fas fa-globe-americas text-warning mr-1"></i> Global Scholars</span>
            <span className="fs-5 font-weight-bold text-muted"><i className="fas fa-graduation-cap text-warning mr-1"></i> Apex Overseas</span>
            <span className="fs-5 font-weight-bold text-muted"><i className="fas fa-briefcase text-warning mr-1"></i> NextGen Education</span>
            <span className="fs-5 font-weight-bold text-muted"><i className="fas fa-university text-warning mr-1"></i> EdVantage Consultancy</span>
            <span className="fs-5 font-weight-bold text-muted"><i className="fas fa-plane text-warning mr-1"></i> Orbit Study Abroad</span>
          </div>
        </div>
      </section>

      {/* 3. THE BUSINESS PROBLEM */}
      <section className="py-5 container">
        <div className="consultancy-section-header text-center mb-5">
          <span className="consultancy-badge-gold mb-2">Industry Bottlenecks</span>
          <h2 className="display-6 font-weight-bold consultancy-gold-title mb-0">Managing an Education Consultancy Shouldn't Mean Managing Spreadsheets</h2>
          <p className="consultancy-lead-text mx-auto mt-2" style={{ maxWidth: "680px" }}>
            Manual operations slow down enquiry response times, cause document misplacement, and limit consultancy growth.
          </p>
        </div>

        <div className="row g-4">
          {problems.map((p, idx) => (
            <div key={idx} className="col-lg-4 col-md-6 mb-4">
              <div className="consultancy-glass-card p-4 h-100">
                <i className={`fas ${p.icon} text-warning fa-2x mb-3`}></i>
                <h5 className="font-weight-bold text-white mb-2">{p.title}</h5>
                <p className="text-muted small mb-0" style={{ lineHeight: "1.7" }}>{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 4. THE SOLUTION */}
      <section className="py-5 consultancy-section-dark">
        <div className="container text-center">
          <div className="consultancy-section-header text-center mb-5">
            <span className="consultancy-badge-gold mb-2">The EdOps Solution</span>
            <h2 className="display-6 font-weight-bold consultancy-gold-title mb-2">One Platform. Your Entire Consultancy.</h2>
            <p className="consultancy-lead-text mx-auto" style={{ maxWidth: "650px" }}>
              A unified cloud operating system connecting every department, branch office, and counsellor in real time.
            </p>
          </div>

          <div className="consultancy-modules-grid">
            {solutionModules.map((mod, idx) => (
              <div key={idx} className="consultancy-module-card">
                <div className="consultancy-module-icon-wrap">
                  <i className={`fas ${mod.icon} text-warning`}></i>
                </div>
                <div className="consultancy-module-info">
                  <h6 className="consultancy-module-title">{mod.title}</h6>
                  <p className="consultancy-module-desc">{mod.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 5. INTERACTIVE PRODUCT OVERVIEW SHOWCASE */}
      <section className="py-5 container">
        <div className="consultancy-section-header text-center mb-4">
          <span className="consultancy-badge-gold mb-2">Interactive Software Showcase</span>
          <h2 className="display-6 font-weight-bold consultancy-gold-title mb-0">Explore the Operating Modules</h2>
        </div>

        {/* Tab Selector */}
        <div className="d-flex justify-content-center gap-2 mb-4 flex-wrap">
          {[
            { id: "crm", label: "Counselling CRM", icon: "fa-users" },
            { id: "apps", label: "Application Pipeline", icon: "fa-file-alt" },
            { id: "counsellors", label: "Counsellor Leaderboard", icon: "fa-user-tie" },
            { id: "analytics", label: "Branch Analytics", icon: "fa-chart-pie" },
          ].map((t) => (
            <button
              key={t.id}
              className={`btn font-weight-bold px-4 py-2 rounded-pill ${activeTab === t.id ? "btn-warning text-dark" : "btn-outline-secondary text-white"}`}
              onClick={() => setActiveTab(t.id)}
            >
              <i className={`fas ${t.icon} mr-1`}></i> {t.label}
            </button>
          ))}
        </div>

        {/* Dynamic Tab Visual Content */}
        <div className="consultancy-glass-card p-4 p-md-5">
          {activeTab === "crm" && (
            <div>
              <h4 className="consultancy-gold-title font-weight-bold mb-3">1. Student CRM & Lead Pipeline</h4>
              <p className="text-muted small mb-4">Capture enquiries automatically, calculate lead scores, and assign follow-up tasks to counsellors.</p>
              <div className="row g-3">
                {pipelineStages.slice(0, 4).map((st, i) => (
                  <div key={i} className="col-md-3">
                    <div className="consultancy-pill-card">
                      <strong className="text-white d-block mb-1">{st.title}</strong>
                      <span className="consultancy-gold-text font-weight-bold fs-4">{st.count} Leads</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "apps" && (
            <div>
              <h4 className="consultancy-gold-title font-weight-bold mb-3">2. End-to-End Application Pipeline</h4>
              <p className="text-muted small mb-4">Track student applications from shortlisting to offer letter, CAS issuance, visa filing, and final enrollment.</p>
              <div className="row g-3">
                {pipelineStages.slice(3, 7).map((st, i) => (
                  <div key={i} className="col-md-3">
                    <div className="consultancy-pill-card">
                      <strong className="text-white d-block mb-1">{st.title}</strong>
                      <span className="consultancy-gold-text font-weight-bold fs-4">{st.count} Applications</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "counsellors" && (
            <div>
              <h4 className="consultancy-gold-title font-weight-bold mb-3">3. Counsellor Productivity Leaderboard</h4>
              <p className="text-muted small mb-4">Monitor counsellor conversion metrics, active student cases, and revenue contribution.</p>
              <div className="row g-3">
                {counsellors.map((c) => (
                  <div key={c.rank} className="col-md-4">
                    <div className="consultancy-pill-card text-center">
                      <img src={c.avatar} alt={c.name} className="rounded-circle mb-2" style={{ width: "60px", height: "60px", objectFit: "cover", border: "2px solid var(--consultancy-gold-primary)" }} />
                      <h6 className="font-weight-bold text-white mb-0">Rank #{c.rank} - {c.name}</h6>
                      <small className="text-warning font-weight-bold d-block mt-1">Conversion: {c.conversion}</small>
                      <small className="text-muted d-block">Revenue: {c.revenue}</small>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === "analytics" && (
            <div>
              <h4 className="consultancy-gold-title font-weight-bold mb-3">4. Multi-Branch Performance Analytics</h4>
              <p className="text-muted small mb-4">Compare conversion metrics, revenue generated, and application volume across all office locations.</p>
              <div className="table-responsive">
                <table className="table table-dark table-striped align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Branch Office</th>
                      <th>Total Leads</th>
                      <th>Applications</th>
                      <th>Revenue Settled</th>
                      <th>Conversion %</th>
                    </tr>
                  </thead>
                  <tbody>
                    {branches.map((b, i) => (
                      <tr key={i}>
                        <td className="font-weight-bold text-warning">{b.branch}</td>
                        <td>{b.leads}</td>
                        <td>{b.applications}</td>
                        <td className="text-success font-weight-bold">{b.revenue}</td>
                        <td><span className="badge bg-warning text-dark">{b.conversion}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* 6. COUNSELLOR MANAGEMENT */}
      <section className="py-5 consultancy-section-dark">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6">
              <span className="consultancy-badge-gold mb-2">Team Productivity</span>
              <h2 className="display-6 font-weight-bold consultancy-gold-title mb-3">Give Your Counsellors Everything They Need to Convert Better</h2>
              <p className="text-muted" style={{ lineHeight: "1.8" }}>
                Empower your counsellors with daily follow-up task queues, student profile histories, automated WhatsApp reminders, and quick university shortlisting.
              </p>
              <div className="d-flex flex-column gap-2 mt-3 text-white small font-weight-bold">
                <div><i className="fas fa-check-circle text-warning mr-2"></i> Automated Daily Follow-Up Reminders</div>
                <div><i className="fas fa-check-circle text-warning mr-2"></i> Instant University Eligibility Checker</div>
                <div><i className="fas fa-check-circle text-warning mr-2"></i> Integrated Student Communication History</div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="consultancy-glass-card p-4">
                <h5 className="consultancy-gold-title font-weight-bold mb-3">Top Performing Counsellors This Month</h5>
                {counsellors.map((c) => (
                  <div key={c.rank} className="d-flex align-items-center justify-content-between p-3 rounded mb-2 consultancy-pill-card">
                    <div className="d-flex align-items-center gap-3">
                      <span className="bg-warning text-dark font-weight-bold fs-6 px-2 py-1 rounded">#{c.rank}</span>
                      <div>
                        <strong className="text-white d-block">{c.name}</strong>
                        <small className="text-muted">{c.leads} Leads Assigned</small>
                      </div>
                    </div>
                    <div className="text-end">
                      <strong className="text-success d-block">{c.revenue}</strong>
                      <small className="text-warning font-weight-bold">{c.conversion} Conv.</small>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 7. UNIVERSITY & PARTNER MANAGEMENT */}
      <section className="py-5 container">
        <div className="consultancy-section-header text-center mb-5">
          <span className="consultancy-badge-gold mb-2">University Network</span>
          <h2 className="display-6 font-weight-bold consultancy-gold-title mb-0">Manage Your University Network in One Place</h2>
          <p className="consultancy-lead-text mx-auto mt-2" style={{ maxWidth: "650px" }}>
            Track partner university agreements, commission rates, application fee waivers, and offer turnaround times.
          </p>
        </div>

        <div className="row g-4">
          {[
            { title: "Partner University Catalog", desc: "1,000+ accredited universities across UK, US, Canada, Germany & Australia with instant course lookup.", icon: "fa-university" },
            { title: "Commission Rate Tracking", desc: "Real-time visibility into agreement commission percentages, sub-agent splits, and payout timelines.", icon: "fa-money-bill-wave" },
            { title: "Offer Turnaround SLAs", desc: "Monitor average offer letter processing speeds by university to guide student expectations.", icon: "fa-clock" },
          ].map((u, idx) => (
            <div key={idx} className="col-md-4">
              <div className="consultancy-glass-card p-4 h-100">
                <i className={`fas ${u.icon} text-warning fa-2x mb-3`}></i>
                <h5 className="font-weight-bold consultancy-gold-title mb-2">{u.title}</h5>
                <p className="text-muted small mb-0">{u.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 8. BUSINESS ANALYTICS */}
      <section className="py-5 consultancy-section-dark">
        <div className="container text-center">
          <div className="consultancy-section-header text-center mb-5">
            <span className="consultancy-badge-gold mb-2">Executive Business Intelligence</span>
            <h2 className="display-6 font-weight-bold consultancy-gold-title mb-0">Know Exactly How Your Consultancy Is Performing</h2>
          </div>

          <div className="row g-4 mt-4">
            <div className="col-md-3 col-6">
              <div className="consultancy-stat-card">
                <div className="consultancy-stat-number">40%</div>
                <div className="text-muted small mt-2">Less Admin Work</div>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="consultancy-stat-card">
                <div className="consultancy-stat-number">30%</div>
                <div className="text-muted small mt-2">Faster Follow-Ups</div>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="consultancy-stat-card">
                <div className="consultancy-stat-number">25%</div>
                <div className="text-muted small mt-2">Higher Lead Conversion</div>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="consultancy-stat-card">
                <div className="consultancy-stat-number">50%</div>
                <div className="text-muted small mt-2">Better Visibility</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 9. INTEGRATIONS & SECURITY */}
      <section className="py-5 container">
        <div className="consultancy-security-section-grid">
          <div className="d-flex flex-column justify-content-between h-100">
            <div>
              <span className="consultancy-badge-gold mb-2">Enterprise Security & Ecosystem</span>
              <h2 className="display-6 font-weight-bold consultancy-gold-title mb-3">Seamless Integrations & Enterprise Security</h2>
              <p className="text-muted mb-0" style={{ lineHeight: "1.7" }}>
                Connect EdOps OS with your existing communication, email, and accounting tools while keeping student documents protected with enterprise encryption.
              </p>
            </div>

            <div className="consultancy-integrations-grid">
              {integrations.map((ig, i) => (
                <div key={i} className="consultancy-integration-item">
                  <div className="consultancy-integration-icon">
                    <i className={`${ig.icon}`}></i>
                  </div>
                  <span className="consultancy-integration-name">{ig.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="consultancy-glass-card consultancy-security-card p-4 p-md-5">
              <div className="d-flex align-items-center gap-3 mb-3">
                <div className="consultancy-security-icon-circle">
                  <i className="fas fa-lock text-warning fa-lg"></i>
                </div>
                <div>
                  <h4 className="consultancy-gold-title font-weight-bold mb-0">Role-Based Access & Security</h4>
                  <small className="text-muted">Enterprise Data Protection</small>
                </div>
              </div>

              <p className="text-muted small mb-4" style={{ lineHeight: "1.7" }}>
                Enforce granular user role permissions for Super Admins, Agency Directors, Counsellors, Application Assistants, and Loan Officers.
              </p>

              <ul className="consultancy-security-list mb-0">
                <li><i className="fas fa-shield-alt text-warning fa-lg"></i> Encrypted Student Document Storage</li>
                <li><i className="fas fa-shield-alt text-warning fa-lg"></i> Multi-Tenant Branch Isolation</li>
                <li><i className="fas fa-shield-alt text-warning fa-lg"></i> Detailed Audit & Activity Logs</li>
                <li><i className="fas fa-shield-alt text-warning fa-lg"></i> Automated Daily Backups & 99.9% Uptime</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 10. PRICING PLANS */}
      <section className="py-5 consultancy-section-dark" id="pricing">
        <div className="container text-center">
          <div className="consultancy-section-header text-center mb-5">
            <span className="consultancy-badge-gold mb-2">Transparent Pricing</span>
            <h2 className="display-6 font-weight-bold consultancy-gold-title mb-0">Plans Designed to Scale With Your Consultancy</h2>
          </div>

          <div className="row g-4">
            {[
              { plan: "Starter Plan", price: "₹4,999 / mo", desc: "For single-office consultancies starting out", leads: "Up to 500 Leads / mo", staff: "Up to 5 Counsellors", features: ["Student CRM & Lead Pipeline", "AI University Shortlisting", "Document Storage (10 GB)", "Email Support"] },
              { plan: "Growth Plan", price: "₹12,999 / mo", desc: "For growing agencies with multiple branches", leads: "Up to 2,500 Leads / mo", staff: "Up to 20 Staff Users", features: ["Full Operating OS Suite", "Multi-Branch Analytics", "Automated SOP/LOR Builder", "Commission Engine", "WhatsApp Integration", "Priority Support"] },
              { plan: "Enterprise Plan", price: "Custom Pricing", desc: "For large consultancy networks & franchises", leads: "Unlimited Leads", staff: "Unlimited Staff & Sub-Agents", features: ["Dedicated Server Instance", "Custom API Integrations", "Sub-Agent Commission Portal", "24/7 Phone SLA", "Dedicated Account Manager"] },
            ].map((pr, idx) => (
              <div key={idx} className="col-lg-4">
                <div className="consultancy-glass-card p-4 h-100 d-flex flex-column justify-content-between">
                  <div>
                    {idx === 1 && (
                      <span 
                        className="badge bg-warning text-dark font-weight-bold px-3 py-2 text-uppercase"
                        style={{
                          position: "absolute",
                          top: "-14px",
                          left: "50%",
                          transform: "translateX(-50%)",
                          borderRadius: "20px",
                          letterSpacing: "1px",
                          boxShadow: "0 4px 12px rgba(212, 175, 55, 0.4)",
                          zIndex: 10
                        }}
                      >
                        Most Popular Choice
                      </span>
                    )}
                    <h4 className="font-weight-bold consultancy-gold-title mb-1">{pr.plan}</h4>
                    <small className="text-muted d-block mb-3">{pr.desc}</small>
                    <div className="display-6 font-weight-bold text-white mb-3">{pr.price}</div>

                    <ul className="list-unstyled text-start small d-flex flex-column gap-2 mb-4 text-muted">
                      <li className="text-white font-weight-bold"><i className="fas fa-check text-warning mr-2"></i> {pr.leads}</li>
                      <li className="text-white font-weight-bold"><i className="fas fa-check text-warning mr-2"></i> {pr.staff}</li>
                      {pr.features.map((f, i) => (
                        <li key={i}><i className="fas fa-check text-warning mr-2"></i> {f}</li>
                      ))}
                    </ul>
                  </div>

                  <Link to="/consultancy/book-consultation" className="consultancy-btn-gold w-100 py-3 text-center">
                    Book a Demo <i className="fas fa-desktop ml-1"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 11. FAQ SECTION */}
      <section className="py-5 container">
        <div className="consultancy-section-header text-center mb-5">
          <span className="consultancy-badge-gold mb-2">Business FAQ</span>
          <h2 className="display-6 font-weight-bold consultancy-gold-title mb-0">Frequently Asked Questions</h2>
        </div>

        <div className="mx-auto" style={{ maxWidth: "850px" }}>
          {faqs.map((faq, idx) => (
            <div key={idx} className="consultancy-accordion-item">
              <div
                className="consultancy-accordion-header"
                onClick={() => setOpenFaq(openFaq === idx ? -1 : idx)}
              >
                <span>{faq.q}</span>
                <i className={`fas ${openFaq === idx ? "fa-minus" : "fa-plus"} text-warning`}></i>
              </div>
              {openFaq === idx && (
                <div className="consultancy-accordion-body">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* 12. FINAL HIGH-IMPACT DEMO CTA */}
      <section className="py-5 container">
        <div className="consultancy-glass-card p-5 text-center position-relative overflow-hidden">
          <div className="position-relative z-2">
            <h2 className="display-5 font-weight-bold consultancy-gold-title mb-3">Ready to Build a Smarter Overseas Education Consultancy?</h2>
            <p className="consultancy-lead-text mx-auto mb-4" style={{ maxWidth: "680px" }}>
              Bring your leads, counsellors, applications, universities, and business analytics into one powerful intelligent AI SaaS platform.
            </p>
            <div className="d-flex justify-content-center gap-3 flex-wrap">
              <Link to="/consultancy/book-consultation" className="consultancy-btn-gold px-5 py-3">
                Book a Personalized Demo <i className="fas fa-desktop ml-1"></i>
              </Link>
              <Link to="/consultancy/contact" className="consultancy-btn-outline-gold px-5 py-3">
                Talk to Our Team <i className="fas fa-phone-alt ml-1"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default ConsultancyHome;
